/**
 * Configuration du routeur principal de l'application administrateur.
 *
 * Ce module :
 * - importe les routes définies dans main.router
 * - initialise le routeur avec l'historique HTML5 (createWebHistory)
 * - exporte le routeur prêt à être utilisé dans l'application Vue
 *
 * Utilise createRouter et createWebHistory fournis par Vue Router.
 */
import {
  createRouter,
  createWebHistory,
  type RouteRecordRaw,
} from 'vue-router';
import admin_router from './main.router';
import { token, rolesArray } from '@/refs/common.refs';

const routes: Array<RouteRecordRaw> = [...admin_router];

const admin_main_router = createRouter({
  history: createWebHistory(),
  routes,
  scrollBehavior: () => ({ top: 0 }),
});

admin_main_router.beforeEach((to, from, next) => {
  const isLoggedIn = !!token.value?.accessToken;
  // 'auth' et 'blank' sont des pages publiques (pas besoin d'être connecté)
  const isPublic = to.meta.layout === 'blank' || to.meta.layout === 'auth';

  // analytics_viewer n'a accès qu'au menu Analytics dans la sidebar : le
  // laisser naviguer ailleurs (rechargement, lien direct, historique
  // navigateur) l'amènerait sur une page qu'il ne peut pas voir.
  const roles = (rolesArray.value ?? []) as string[];
  const isAnalyticsViewerOnly =
    roles.length === 1 && roles[0] === 'analytics_viewer';

  if (!isPublic && !isLoggedIn) {
    next({ name: 'Login' });
  } else if (to.name === 'Login' && isLoggedIn) {
    next({ name: isAnalyticsViewerOnly ? 'Analytics' : 'Dashboard' });
  } else if (
    isLoggedIn &&
    isAnalyticsViewerOnly &&
    !isPublic &&
    to.name !== 'Analytics'
  ) {
    next({ name: 'Analytics' });
  } else {
    next();
  }
});

export default admin_main_router;
